import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

const RenList = ({ data, accessor, columnData }) => {
  const { className } = columnData;
  return (
    <ul className={clsx('tbl-ren-list-cont', className)}>
      {data[accessor].map((
        item,
      ) => (
        <li className="tbl-ren-list" key={item}>{item}</li>
      ))}
    </ul>
  );
};

RenList.defaultProps = {
  data: {},
  columnData: {
    className: '',
  },
};

RenList.propTypes = {
  accessor: PropTypes.string.isRequired,
  data: PropTypes.shape(),
  columnData: PropTypes.shape({
    className: PropTypes.string,
  }),
};

export default RenList;
